/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_RevisionInputs */

const en_po_field_revision = /** @type {(inputs: Po_Field_RevisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revision`)
};

/**
* | output |
* | --- |
* | "Revision" |
*
* @param {Po_Field_RevisionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_revision = /** @type {((inputs?: Po_Field_RevisionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_RevisionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_revision(inputs)
});